<script>
import Switchery from '@/system/components/global/form/Switchery';

export default {
    data() {
        return {
            override: false,
            onSuccess: null,
            onCancel: null,
            heading: null,
            type: null,
        };
    },

    mounted() {
        this.$event_bus.$on('confirmEmployeeOverride', ({onSuccess, onCancel, heading, type}) => {
            this.onSuccess = onSuccess;
            this.onCancel = onCancel;
            this.heading = heading;
            this.type = type;
            $('#override-employees-confirmation-modal').modal('show');
        });

        $('#override-employees-confirmation-modal').on('hidden.bs.modal', () => {
            if (typeof this.onCancel === 'function') {
                this.onCancel();
            }
        });
    },

    methods: {
        confirm() {
            if (typeof this.onSuccess === 'function') {
                this.onSuccess(this.override);
            }

            $('#override-employees-confirmation-modal').modal('hide');
            this.override = 0;
        },
    },

    components: { Switchery },
}
</script>

<template>
    <div
        id="override-employees-confirmation-modal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        style="display: none;"
    >
        <div class="override-employees-templates-modal">
            <div class="modal-dialog">
                <div class="panel panel-color panel-inverse m-0">
                    <div class="panel-heading">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="panel-title">{{ trans('messages.override_all_selected_employee_templates') }}</h3>
                    </div>
                </div>

                <div class="modal-content">
                    <div class="modal-body p-0">
                        <div class="row">
                            <div class="col-xs-12">
                                <ep-banner>{{ trans('messages.override_all_employees_confirmation', { template: heading, email_sms: type }) }}</ep-banner>

                                <switchery
                                    class="m-b-0 m-t-10"
                                    :text="trans('messages.override_all_selected_employee_templates')"
                                    name="override_employees_templates"
                                    identifier="override_employees_templates"
                                    v-model="override"
                                    :editable="1">
                                </switchery>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer m-t-10">
                        <ep-button variant="tertiary" class="mr-5" data-dismiss="modal">{{ trans('global.cancel') }}</ep-button>
                        <ep-button type="submit" @click="confirm">{{ trans('global.continue') }}</ep-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
